<template>
  <div>
    <div class="p-button-month-select">
      <div></div>
    </div>
    <div class="calendar-vertical__filter p-calendar-vertical__filter">
      <div class="calendar-vertical-filter__form">
        <div
          class="calendar-vertical__input calendar-vertical__input--desktop-width-25"
        >
          <dpc-p-input-text />
        </div>
        <div
          class="calendar-vertical__input calendar-vertical__input--desktop-width-25"
        >
          <dpc-p-input-text />
        </div>
        <div
          class="calendar-vertical__input calendar-vertical__input--desktop-width-25"
        >
          <dpc-p-input-text />
        </div>
        <div
          class="calendar-vertical__input calendar-vertical__input--desktop-width-25"
        >
          <dpc-p-input-text />
        </div>
      </div>
    </div>
    <dpc-p-calendar-event-list />
  </div>
</template>
